import React, { useState, useEffect, useRef } from "react";
import "./Faq.scss";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    contentRefs.current.forEach((content, i) => {
      if (content) {
        if (i === activeIndex) {
          content.style.maxHeight = `${content.scrollHeight}px`; // Expand to full height
        } else {
          content.style.maxHeight = "0"; // Collapse smoothly
        }
      }
    });
  }, [activeIndex]);

  const accordionData = [
    {
      question: "What is a housing disrepair claim?",
      answer:
        "A housing disrepair claim allows tenants to take legal action against landlords who fail to keep their property in a safe, livable condition. This includes issues like damp, mold, leaks, broken heating, or structural defects.",
    },
    {
      question: "Am I eligible to claim?",
      answer:
        "If you're a Council or Housing Association tenant, have ongoing repair issues like those mentioned, and have reported the problems to your landlord, you may qualify to make a claim.",
    },
    {
      question: "What is the claims process?",
      answer:
        "The timeline varies but can take from weeks to up to a year depending on your landlord. Our team will ensure no delays from our side and will push your landlord to begin repairs promptly.",
    },
    {
      question: "Will claiming affect my relationship with my landlord?",
      answer:
        "By law, landlords are required to maintain properties to a livable standard under the Landlord and Tenant Act (1985) and the Fitness for Human Habitation Act. You have the legal right to a safe home, and your landlord must act in your best interests.",
    },
    {
      question: "How is compensation determined?",
      answer:
        "Compensation depends on factors such as the duration of disrepair, the severity of the problem, its impact on tenants, damage to belongings, and whether it has caused any health issues.",
    },
  ];

  return (
    <section className="faq">
      <div className="container1286">
        <div className="faq-accordion">
          <div className="faq-accordion-details">
            <h2>
              {" "}
              Frequently Asked <strong>Questions</strong>{" "}
            </h2>
            <p>Need more info? look no further.</p>
          </div>
          {accordionData.map((item, index) => (
            <div
              className={`accordion-item ${
                activeIndex === index ? "active" : ""
              }`}
              key={index}
            >
              <div
                className="accordion-label"
                onClick={() => toggleAccordion(index)}
              >
                <span className="accordion-question">{item.question}</span>
                <span className="icon">
                  <div className="plus-icon">
                    <div className="bar-one"></div>
                    <div className="bar-two"></div>
                  </div>
                </span>
              </div>
              <div
                className="accordion-content"
                ref={(el) => (contentRefs.current[index] = el)}
                style={{
                  overflow: "hidden",
                  transition: "max-height 0.5s ease",
                }}
              >
                <p>{item.answer}</p>
                <br />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
